export default __webpack_public_path__ + "static/media/timer_play_inactive.4e4b4122.svg";